import moment from 'moment';
import { formatDateOnly } from '../../../../../insfrastructure/utils/date-formatter';

export const formatDate = (date: string | Date | null | undefined): string => {
  if (!date) return '';
  try {
    return moment(date).format('DD/MM/YYYY');
  } catch (error) {
    console.error('Erro ao formatar data:', error);
    return '';
  }
};

export const formatCPF = (cpf: string): string => {
  if (!cpf) return '';
  const numbers = cpf.replace(/\D/g, '');
  if (numbers.length !== 11) return cpf;
  return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

export const formatCNPJ = (cnpj: string): string => {
  if (!cnpj) return '';
  const numbers = cnpj.replace(/\D/g, '');
  if (numbers.length !== 14) return cnpj;
  return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
};

export const formatPhone = (phone: string): string => {
  if (!phone) return '';
  const numbers = phone.replace(/\D/g, '');
  if (numbers.length === 11) {
    return numbers.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  } else if (numbers.length === 10) {
    return numbers.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }
  return phone;
};

export const formatDateForAPI = (date: Date | string | null | undefined): string => {
  if (!date) return '';
  // Usa formatDateOnly que já trata strings no formato DD/MM/YYYY
  const formatted = formatDateOnly(date);
  return formatted || '';
};

export const removeFormatting = (value: string): string => {
  return value.replace(/\D/g, '');
};

